var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.34 11.63a12.13 12.13 0 01-11.52 16.49h-1.15c-.34 0-.68-.09-1-.16l-.48-.11-.54-.14-.56-.18-.42-.15-.59-.24-.29-.14c-.21-.1-.43-.2-.63-.32a12.2 12.2 0 01-5.48-6.27c-.13-.35-.25-.7-.35-1.05l-.06-.21c-.08-.31-.15-.62-.2-.92a2.9 2.9 0 01-.07-.47c0-.24-.08-.49-.1-.74v-.59a12.12 12.12 0 0118-11l.27.15-.99 1.62H27l-3-5-1 1.71-.26-.14A14 14 0 002 16v1.46c0 .15.06.37.09.56a8.89 8.89 0 00.15.9l.06.25c.1.4.2.8.33 1.19a14 14 0 0011.14 9.41c.23 0 .46.08.68.1h.31c.37 0 .74.06 1.11.06a14 14 0 0013.41-18.37z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--circle-arrow-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'CircleArrowIcon';
export default Icon;